(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["copy-discount-code"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.copy-discount-code').forEach(function (btn) {
    if (btn._cdcBound) return;
    btn._cdcBound = true;
    btn.addEventListener('click', function () {
      var code = btn.dataset.discountCode;
      if (!code) return;
      navigator.clipboard.writeText(code).then(function () {
        btn.classList.add('is-copied');
        setTimeout(function () {
          btn.classList.remove('is-copied');
        }, 5000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    const target = event.target;
    const form = target.closest('form');
    if (!form) return;
    const name = 'filter.v.m.nevios.availability';
    const options = Array.from(form.querySelectorAll('input')).filter(input => input.name === name);
    const stock = options.find(input => input.value === 'Skladem na e-shopu');
    if (target.matches('[data-stock-switch]')) {
      event.stopImmediatePropagation();
      if (!stock) return;
      if (target.checked) options.forEach(input => { input.checked = false; });
      stock.checked = target.checked;
      if (!form.closest('filters-drawer-component')) form.closest('facets-form-component')?.updateFilters();
    } else if (target.name === name) {
      if (target.checked && stock) {
        if (target === stock) options.forEach(input => { if (input !== stock) input.checked = false; });
        else stock.checked = false;
      }
      form.querySelectorAll('[data-stock-switch]').forEach(input => { input.checked = !!stock?.checked; });
    }
  }, true);

  class FiltersDrawerComponent extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector('.olaola-filters__drawer');
      this.backdrop = this.querySelector('.olaola-filters__drawer-backdrop');
      this.isOpen = false;
      this.scrollPosition = 0;
    }

    connectedCallback() {
      // Close buttons
      this.querySelectorAll('[data-close-drawer]').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      // Apply button — close drawer first, then submit filters
      const applyBtn = this.querySelector('[data-apply-filters]');
      if (applyBtn) {
        applyBtn.addEventListener('click', () => this.applyAndClose());
      }

      // Clear button — reset all inputs in the drawer form
      const clearBtn = this.querySelector('[data-clear-drawer-filters]');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          this.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
            input.checked = false;
          });
          this.querySelectorAll('input[type="text"], input[type="number"]').forEach(input => {
            input.value = '';
          });
          clearBtn.classList.remove('active');
        });
      }

      // Open buttons (delegated to document)
      this._handleOpen = (e) => {
        const openBtn = e.target.closest(`[data-open-drawer="${this.id}"]`);
        if (openBtn) {
          e.preventDefault();
          const scrollTo = openBtn.dataset.scrollTo;
          this.open(scrollTo);
        }
      };
      document.addEventListener('click', this._handleOpen);

      // Close on escape
      this._handleEscape = (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      };
      document.addEventListener('keydown', this._handleEscape);
    }

    disconnectedCallback() {
      // Clean up document-level listeners to prevent leaks
      if (this._handleOpen) document.removeEventListener('click', this._handleOpen);
      if (this._handleEscape) document.removeEventListener('keydown', this._handleEscape);

      // If element is removed while drawer is open (e.g. section re-render),
      // make sure to unlock body scroll
      if (this.isOpen) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, this.scrollPosition);
        document.documentElement.style.scrollBehavior = '';
      }
    }

    open(scrollTo = null) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.scrollPosition = window.scrollY;

      // Lock body scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';

      // Step 1: Open the accordion FIRST (before showing drawer)
      if (scrollTo) {
        const accordion = this.querySelector(`[data-filter-param-name="${scrollTo}"]`);
        if (accordion) {
          const details = accordion.querySelector('details');
          if (details) {
            details.open = true;
          }
        }
      }

      // Step 2: Make visible (but still translated off-screen)
      this.classList.add('is-visible');

      // Step 3: Trigger slide-in animation on next frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.add('is-active');

          // Step 4: Scroll to the accordion within the drawer's scroll container
          if (scrollTo) {
            setTimeout(() => {
              const accordion = this.querySelector(`[data-filter-param-name="${scrollTo}"]`);
              const scrollContainer = this.querySelector('.olaola-filters__bottom-sheet-content');
              if (accordion && scrollContainer) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const accordionRect = accordion.getBoundingClientRect();
                scrollContainer.scrollTo({
                  top: scrollContainer.scrollTop + (accordionRect.top - containerRect.top),
                  behavior: 'smooth'
                });
              }
            }, 100);
          }
        });
      });
    }

    applyAndClose() {
      if (!this.isOpen) return;

      // Capture form data before closing
      const facetsForm = this.querySelector('facets-form-component');

      // Close drawer first (unlocks body scroll)
      this.isOpen = false;
      const savedScroll = this.scrollPosition;

      this.classList.remove('is-active');

      setTimeout(() => {
        this.classList.remove('is-visible');

        // Unlock body scroll
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, savedScroll);
        document.documentElement.style.scrollBehavior = '';

        // Now apply filters (this may re-render the section)
        if (facetsForm && typeof facetsForm.updateFilters === 'function') {
          facetsForm.updateFilters();
        }
      }, 300);
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;

      // Capture scroll position before clearing
      const savedScroll = this.scrollPosition;

      // Step 1: Start closing animation
      this.classList.remove('is-active');

      // Step 2: After animation completes, hide completely
      setTimeout(() => {
        this.classList.remove('is-visible');

        // Unlock body scroll
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, savedScroll);
        document.documentElement.style.scrollBehavior = '';
      }, 300);
    }
  }

  if (!customElements.get('filters-drawer-component')) {
    customElements.define('filters-drawer-component', FiltersDrawerComponent);
  }

  // Desktop filter dropdown toggle functionality
  function showOverlay() {
    const overlay = document.querySelector('[data-filter-overlay]');
    if (overlay) overlay.classList.add('is-visible');
  }

  function hideOverlay() {
    const overlay = document.querySelector('[data-filter-overlay]');
    if (overlay) overlay.classList.remove('is-visible');
  }

  function closeAllDropdowns() {
    document.querySelectorAll('[data-filter-dropdown-trigger]').forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      const wrapper = trigger.closest('[data-filter-dropdown]');
      const dropdown = wrapper ? wrapper.querySelector('[data-filter-dropdown-content]') : null;
      if (dropdown) dropdown.classList.remove('is-open');
    });
    hideOverlay();
  }

  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-filter-dropdown-trigger]');
    const overlay = event.target.closest('[data-filter-overlay]');
    
    // Close dropdowns when clicking on overlay
    if (overlay) {
      closeAllDropdowns();
      return;
    }
    
    if (trigger) {
      event.preventDefault();
      
      const wrapper = trigger.closest('[data-filter-dropdown]');
      const dropdown = wrapper ? wrapper.querySelector('[data-filter-dropdown-content]') : null;
      
      if (!dropdown) return;
      
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      // Close all other dropdowns first
      document.querySelectorAll('[data-filter-dropdown-trigger]').forEach(function(otherTrigger) {
        if (otherTrigger !== trigger) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          const otherWrapper = otherTrigger.closest('[data-filter-dropdown]');
          const otherDropdown = otherWrapper ? otherWrapper.querySelector('[data-filter-dropdown-content]') : null;
          if (otherDropdown) otherDropdown.classList.remove('is-open');
        }
      });
      
      // Toggle current dropdown
      trigger.setAttribute('aria-expanded', String(!isExpanded));
      if (isExpanded) {
        dropdown.classList.remove('is-open');
      } else {
        dropdown.style.marginLeft = '0px';
        dropdown.classList.add('is-open');
        const bounds = dropdown.getBoundingClientRect();
        const shift = Math.min(0, window.innerWidth - 16 - bounds.right);
        dropdown.style.marginLeft = Math.max(16 - bounds.left, shift) + 'px';
      }
      
      // Toggle overlay
      if (!isExpanded) {
        showOverlay();
      } else {
        hideOverlay();
      }
      return;
    }
    
    // Close dropdowns when clicking outside
    if (!event.target.closest('[data-filter-dropdown]')) {
      closeAllDropdowns();
    }
  });
  
  // Close dropdowns on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeAllDropdowns();
    }
  });

  // Custom discount sort handler (desktop radio)
  document.addEventListener('change', function(event) {
    var radio = event.target.closest('[data-custom-sort]');
    if (!radio) return;
    event.stopPropagation();
    event.preventDefault();
    applyDiscountSort();
    closeAllDropdowns();
  });

  // Mobile sort drawer handler
  document.addEventListener('click', function(event) {
    var sortOption = event.target.closest('[data-sort-value]');
    if (!sortOption) return;

    var sortValue = sortOption.dataset.sortValue;
    var drawer = sortOption.closest('filters-drawer-component');

    if (sortValue === 'discount-descending') {
      applyDiscountSort();
      if (drawer) drawer.close();
      return;
    }

    // For server-side sorts, update the URL and trigger section render
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('custom_sort');
    history.pushState('', '', url.toString());

    // Close drawer first
    if (drawer) drawer.close();

    // Trigger section re-render via facets form
    var facetsForm = document.querySelector('facets-form-component');
    if (facetsForm && facetsForm.updateFiltersByURL) {
      facetsForm.updateFiltersByURL(url.toString());
    } else {
      window.location.href = url.toString();
    }
  });

  function applyDiscountSort() {
    document.querySelectorAll('.olaola-filters__sort-option').forEach(function(option) {
      var active = option.dataset.sortValue === 'discount-descending';
      option.classList.toggle('olaola-filters__sort-option--active', active);
      option.setAttribute('aria-pressed', String(active));
    });
    // Update badge labels
    document.querySelectorAll('.olaola-filters__badge-wrapper--sort .olaola-filters__badge-label').forEach(function(el) {
      el.textContent = 'Největší sleva';
    });

    // Sort product grid client-side
    var grid = document.querySelector('.product-grid');
    if (grid) {
      var items = Array.from(grid.querySelectorAll('.product-grid__item:not(.product-grid__banner)'));
      items.sort(function(a, b) {
        return (parseInt(b.dataset.discountPct) || 0) - (parseInt(a.dataset.discountPct) || 0);
      });
      items.forEach(function(item) { grid.appendChild(item); });
    }

    // Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('custom_sort', 'discount-descending');
    url.searchParams.delete('sort_by');
    history.pushState('', '', url.toString());
  }
  } catch(e) { console.error(e); }
})();

})();
